<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper top-title" slot="search">
      <span class="ml10 fs13">最早上架时间</span>
      <span class="ml10 fs13">≤</span>
      <a-input-number class="top-title-input ml10" :min="0" v-model="queryParams.earliestShelfTime"></a-input-number>
      <span class="ml10 fs13">日</span>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <div>
        <a-form layout="inline" :labelCol="{ style: { width: '85px' } }">
          <a-row>
            <a-col :md="8" :sm="24">
              <a-form-item label="稳定性范围">
                <span class="ml10 fs13">往前</span>
                <a-input-number class="top-title-input ml10" :min="0" v-model="queryParams.rangeStabilityBefore"></a-input-number>
                <span class="ml10 fs13">月</span>
                <span class="ml10 fs13">往后</span>
                <a-input-number class="top-title-input ml10" :min="0" v-model="queryParams.rangeStabilityAfter"></a-input-number>
                <span class="ml10 fs13">月</span>
              </a-form-item>
            </a-col>

            <a-col :md="16" :sm="24">
              <a-form-item label="月均销售范围">
                <span class="ml10 fs13">往前</span>
                <a-input-number class="top-title-input ml10" :min="0" v-model="queryParams.rangeSalesAverageMonthlyBefore"></a-input-number>
                <span class="ml10 fs13">月</span>
                <span class="ml10 fs13">权重</span>
                <a-input-number :precision="1" @change="changeMonthlyBeforeWeights" :step="0.1" class="top-title-input ml10" :min="0" v-model="queryParams.rangeSalesAverageMonthlyBeforeWeights"></a-input-number>

                <span class="ml30 fs13">往后</span>
                <a-input-number class="top-title-input ml10" :min="0" v-model="queryParams.rangeSalesAverageMonthlyAfter"></a-input-number>
                <span class="ml10 fs13">月</span>
                <span class="ml10 fs13">权重</span>
                <a-input-number disabled :precision="1" @change="changeMonthlyAfterWeights" :step="0.1" class="top-title-input ml10" :min="0" v-model="queryParams.rangeSalesAverageMonthlyAfterWeights"></a-input-number>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-button @click="addLine" type="primary" v-hasPermi="['scp:sopClassifyDefinitionHead:add']">新增</a-button>
      <a-button @click="handleSaveAlert" type="primary">保存</a-button>

    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
        >
          <span slot="orderTypeRenderTitle">
            <i class="toRequired">*</i>下单类别
          </span>
          <span slot="inputNumberTitle">
            <i class="toRequired">*</i>销量区间(从)
          </span>
          <span slot="salesToTitle">
            <i class="toRequired">*</i>销量区间(到)
          </span>
          <span slot="stabilityFromTitle">
            <i class="toRequired">*</i>稳定性区间(从)
          </span>
          <span slot="stabilityToTitle">
            <i class="toRequired">*</i>稳定性区间(到)
          </span>
          <span slot="classifyTitle">
            <i class="toRequired">*</i>类别
          </span>
          <template slot="salesShow" slot-scope="{ record }">
            <span>{{ `(${record.salesFrom} - ${record.salesTo}]` }}</span>
          </template>
          <template slot="stabilityShow" slot-scope="{ record }">
            <span>{{ `(${record.stabilityFrom} - ${record.stabilityTo}]` }}</span>
          </template>
          <template slot="orderTypeRender" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.orderType }}</span>
            <a-select v-if="isEdit && currentId === record.id" show-search option-filter-prop="children" v-model="record.orderType" >
              <a-select-option v-for="(item) in orderTypeOptions" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
            </a-select>
          </template>
          <template slot="classify" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ (classifyOptions.find(item => item.lookupCode === record.classify))?(classifyOptions.find(item => item.lookupCode === record.classify)).lookupValue:'' }}</span>
            <!-- <span v-if="!isEdit || currentId !== record.id">{{ record.classify?record.classify:'' }}</span> -->

            <a-select v-if="isEdit && currentId === record.id" show-search option-filter-prop="children" v-model="record.classify" >
              <a-select-option v-for="(item) in classifyOptions" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
            </a-select>
          </template>
          <template slot="inputNumber" slot-scope="{ record, column }">
            <span v-if="!isEdit || currentId !== record.id">{{ record[column.dataIndex] }}</span>
            <a-input-number v-if="isEdit && currentId === record.id" @change="(val)=>onInputNumberChange(record,column.dataIndex,val)" :min="0" v-model="record[column.dataIndex]"></a-input-number>
          </template>
          <template slot="updateTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="createTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <!-- 操作 -->
          <span slot="operation" slot-scope="{ record, index }">
            <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['scp:sopClassifyDefinitionHead:edit']">编辑</a>
            <a v-if="!isEdit || currentId !== record.id" class="ml10" @click="handleDelete(typeList, record, index)" v-hasPermi="['scp:sopClassifyDefinitionLines:remove']">删除</a>
            <!-- <a v-if="isEdit && currentId === record.id" @click="handleSaveAlert(record)">保存</a>
            <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a> -->
            <a v-if="isEdit && currentId === record.id" @click="isEdit = false" class="ml10">确定</a>
          </span>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

  <script>
  import { listSopClassifyDefinitionHeadList, apiNewlistSopClassifyDefinitionHead, apiDellistSopClassifyDefinitionHead } from '@/api/scp/general-parameter-settings/security-type-definition.js'
  // import { generateLsTableResData } from '@/utils/util.js';
  const generateLsTableResData = (request, serialNumberIs) => {
    return params => {
      return new Promise((resolve, reject) => {
        params.pageNum = params.page;
        delete params.page;
        request(params).then(res => {
          const { data } = res;
          const { linesVOList } = data;
          const { total, rows } = linesVOList;
          if (serialNumberIs) {
            rows.map((item, index) => {
              item.serialNumber = (index + 1) + ((params.pageNum - 1) * params.pageSize)
            })
          }
          const { pageSize } = params
          const pages = Math.ceil(total / pageSize)
          resolve({
            data: {
              state: 100,
              data: {
                records: rows,
                pages,
                total
              }
            }
          })
        }).catch(err => {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject({
            msg: err,
            state: 103
          })
        })
      })
    }
  }
  export default {
    // eslint-disable-next-line
    name: 'Security-type-definition',
    components: {
    },
    data () {
      return {
        classifyOptions: [],
        orderTypeOptions: [],
        typeList: [],
        // 表格配置
        tableProps: {
          requestApi: generateLsTableResData(listSopClassifyDefinitionHeadList, true),
          pageCurrent: true
        },
        isEdit: false,
        currentId: "",
        // 控制搜索展开
        advanced: true,
        // 查询参数
        queryParams: {
          earliestShelfTime: undefined, // 最早上架时间≤ X日
          rangeStabilityBefore: undefined, // 稳定性范围 往前X月
          rangeStabilityAfter: undefined, // 稳定性范围 往后X月
          rangeSalesAverageMonthlyBefore: undefined, // 月均销售范围 往前X月
          rangeSalesAverageMonthlyBeforeWeights: undefined, // 月均销售范围 往后X月 权重
          rangeSalesAverageMonthlyAfter: undefined, // 月均销售范围 往后X月
          rangeSalesAverageMonthlyAfterWeights: undefined // 月均销售范围 往后X月 权重
        },
        // 表格多选
        selectedRowKeys: [],
        selectedRows: [],
        // 状态快码
        statusOptions: [
          {
            dictLabel: "有效",
            dictValue: "Y"
          },
          {
            dictLabel: "无效",
            dictValue: "N"
          }
        ],
        baseUomFlagOptions: [
          {
            dictLabel: "是",
            dictValue: "Y"
          },
          {
            dictLabel: "否",
            dictValue: "N"
          }
        ],
        // 表格字段
        // columns: [
        //   {
        //     // title: '下单类别',
        //     dataIndex: 'orderType',
        //     scopedSlots: { customRender: 'orderTypeRender', title: "orderTypeRenderTitle" },
        //     align: 'center',
        //     width: 160
        //   },
        //   {
        //     // title: '销量区间（从）',
        //     dataIndex: 'salesFrom',
        //     scopedSlots: { customRender: 'inputNumber', title: "inputNumberTitle" },
        //     ellipsis: true,
        //     width: 160,
        //     align: 'center'
        //   },
        //   {
        //     // title: '销量区间（到）',
        //     dataIndex: 'salesTo',
        //     scopedSlots: { customRender: 'inputNumber', title: "salesToTitle" },
        //     ellipsis: true,
        //     width: 160,
        //     align: 'center'
        //   },
        //   {
        //      title: '销量区间',
        //     dataIndex: 'salesShow',
        //     scopedSlots: { customRender: 'salesShow' },
        //     ellipsis: true,
        //     width: this.editWidth,
        //     align: 'center'
        //   },
        //   {
        //     // title: '稳定性区间（从）',
        //     dataIndex: 'stabilityFrom',
        //     width: 160,
        //     scopedSlots: { customRender: 'inputNumber', title: "stabilityFromTitle" },
        //     align: 'center'
        //   },
        //   {
        //     // title: '稳定性区间（到）',
        //     dataIndex: 'stabilityTo',
        //     width: 160,
        //     scopedSlots: { customRender: 'inputNumber', title: "stabilityToTitle" },
        //     align: 'center'
        //   },
        //   {
        //     // title: '类别',
        //     dataIndex: 'classify',
        //     scopedSlots: { customRender: 'classify', title: "classifyTitle" },
        //     width: 170,
        //     align: 'center'
        //   },
        //   {
        //     title: '创建人',
        //     dataIndex: 'createName',
        //     width: 100,
        //     ellipsis: true,
        //     align: 'center'
        //   },
        //   {
        //     title: '创建日期',
        //     dataIndex: 'createTime',
        //     width: 180,
        //     scopedSlots: { customRender: 'createTime' },
        //     align: 'center'
        //   },
        //   {
        //     title: '最后更新人',
        //     dataIndex: 'updateName',
        //     width: 100,
        //     ellipsis: true,
        //     align: 'center'
        //   },
        //   {
        //     title: '最后更新日期',
        //     dataIndex: 'updateTime',
        //     scopedSlots: { customRender: 'updateTime' },
        //     width: 180,
        //     align: 'center'
        //   },
        //   {
        //     title: '操作',
        //     width: 100,
        //     dataIndex: 'operation',
        //     scopedSlots: { customRender: 'operation' },
        //     fixed: 'right'
        //   }
        // ],
        uomClassOptions: [], // 来源分类
        unitOfMeasureList: [], // 来源单位
        unitOfMeasureListNew: [] // 基本单位
      }
    },
    created () {
      const lookupQueryParams = {
          lookupType: 'SCP_ORDER_CATEGORY',
          current: 1,
          pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
      this.orderTypeOptions = response.rows
      })
      const lookupQueryClassifyParams = {
          lookupType: 'SCP_SINV_CLASSIFY',
          current: 1,
          pageSize: 100
      }
      this.getLookupListData(lookupQueryClassifyParams).then().then(response => {
      this.classifyOptions = response.rows.filter(item => item.attribute1 === 'Y'); // 只显示attribute1为Y的
      })
      // this.getPageData()
    },
    mounted () {
      this.onSearch()
      // this.addLine()
    },
    methods: {
      changeMonthlyBeforeWeights (val) {
        this.queryParams.rangeSalesAverageMonthlyAfterWeights = 1 - this.queryParams.rangeSalesAverageMonthlyBeforeWeights
      },
      changeMonthlyAfterWeights (val) {
        this.queryParams.rangeSalesAverageMonthlyBeforeWeights = 1 - this.queryParams.rangeSalesAverageMonthlyAfterWeights
      },
      handleDelete (tableList, record, index) {
        const self = this
        this.$confirm({
          title: '警告',
          content: `真的要删除该项的数据项吗?`,
          okText: '删除',
          okType: 'danger',
          cancelText: '取消',
          onOk () {
            if (record.id) {
            apiDellistSopClassifyDefinitionHead({ id: record.id }).then((response) => {
              if (response.code === 200) {
                self.$message.success('删除成功')
                self.isEdit = false;
                self.getPageData()
              } else {
                self.$message.error(response.msg)
              }
            })
          } else {
            tableList.splice(index, 1);
          }
          }
        })
      },
      isNull (val) {
        if (val === null || val === undefined || val === '') {
          // 变量为空的情况
          return true
        } else {
          // 变量不为空的情况（包括0）
          return false
        }
      },
      getPageData () {
        listSopClassifyDefinitionHeadList().then(response => {
            if (response.code === 200) {
              this.queryParams = { ...this.queryParams, ...response.data };
              if (response.data.linesVOList) {
                const { rows } = response.data.linesVOList;
                if (rows) {
                  this.typeList = rows
                  this.$refs.dataTable.myDataSource = this.typeList
                }
              }
            } else {
              this.$message.error(response.msg)
            }
          })
      },
      onInputNumberChange (record, dataIndex, val) {
             // debugger
      },
      handleSelect (record, type) {

      },
      // 新增行
      addLine () {
        this.typeList = this.$refs.dataTable.myDataSource
        const arr = JSON.parse(JSON.stringify(this.typeList))
        const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
        const obj = {
          classify: "", // 类别
          createName: "", // 创建人名称
          createTime: "", // 创建时间
          orderType: undefined, // 创建时间
          salesFrom: "", // 销量区间起点
          salesTo: "", // 销量区间终点
          scpSopClassifyDefinitionHeadId: "", // 安全库存类别定义表id
          stabilityFrom: "", // 稳定性区间起点
          stabilityTo: "", // 稳定性区间终点
          updateName: "", // 更新人名称
          updateTime: "", // 更新时间

          indexId: Number(indexId) + 1
        }
        arr.push(obj)
        this.typeList = arr
        this.$refs.dataTable.myDataSource = this.typeList
      },
      // 列表-折换字段
      blur (record) {
        if (!record.conversionRate || Number(record.conversionRate) <= 0) {
          this.$message.warning('折换不能为空且需大于0')
        } else {
          record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
        }
      },
      statusOnChange (record) {
        record.status = record.status === 'Y' ? 'N' : 'Y'
      },
      // 导入导出excel
      /** 导出按钮操作 */
      handleExport () {
        this.download('mdm/mdmUomConversions/export', {
          ...this.queryParams
        }, `标准单位转换_${new Date().getTime()}.xlsx`)
      },
      // 编辑
      handleEdit (record) {
        if (this.currentId && record.id !== this.currentId && this.isEdit) {
          this.$message.warning('请保存上次编辑的数据')
          return;
        }
        this.isEdit = true;
        this.currentId = record.id;
      },
      handleSaveAlert (record) {
        if (this.typeList.length === 0) {
            this.$message.warning('未添加行数据')
            return
        }
        let flag = false
        flag = this.checkData()
        if (flag) {
          return false
        }
        for (let i = 0; i < this.typeList.length; i++) {
          if (this.isNull(this.typeList[i].orderType) ||
          this.isNull(this.typeList[i].stabilityFrom) ||
          // this.isNull(this.typeList[i].stabilityTo)) ||
          this.isNull(this.typeList[i].salesFrom) ||
          // this.isNull(this.typeList[i].salesTo)) ||
          this.isNull(this.typeList[i].classify)) {
            this.$message.warning('必填项不能为空！')
            flag = true
            return
          }
        }
        if (flag) {
          return false
        }
          const self = this
          this.$confirm({
          title: `提示`,
          content: '确定保存数据？',
          okText: '确定',
          okType: 'danger',
          cancelText: '取消',
          onOk () {
              self.handleSave(record)
          }
        })
      },
      // 编辑-保存
      handleSave (record) {
      const params = { ...this.queryParams, linesDTOList: this.typeList }
        apiNewlistSopClassifyDefinitionHead(params).then(response => {
          if (response.code === 200) {
            this.$message.success('保存成功')
            this.isEdit = false;
            this.getPageData()
          } else {
            this.$message.error(response.msg)
          }
        })
      },
      checkData () {
        if (!this.queryParams.earliestShelfTime) {
            this.$message.warning('最早上架时间未填写')
            return true
        } else if (!this.queryParams.rangeStabilityBefore) {
            this.$message.warning('稳定性范围往前月份未填写')
            return true
        } else if (!this.queryParams.rangeStabilityAfter) {
            this.$message.warning('稳定性范围往后月份未填写')
            return true
        } else if (!this.queryParams.rangeSalesAverageMonthlyBefore) {
            this.$message.warning('销售范围往前月份未填写')
            return true
        } else if (!this.queryParams.rangeSalesAverageMonthlyBeforeWeights) {
            this.$message.warning('销售范围往前月份的权重未填写')
            return true
        } else if (!this.queryParams.rangeSalesAverageMonthlyAfter) {
            this.$message.warning('销售范围往后月份的未填写')
            return true
        } else if (!this.queryParams.rangeSalesAverageMonthlyAfterWeights) {
            this.$message.warning('销售范围往后月份的权重未填写')
            return true
        }
       return false
      },
      // 取消
      handleCancel (record) {
        this.isEdit = false
        this.onSearch()
      },
      // 新增/修改框事件
      handleOk () {
        this.onSearch()
      },
      // 表单搜索
      onSearch () {
        this.isEdit = false
        this.$refs.dataTable.searchParams = this.queryParams;
        this.$refs.dataTable.getData();
      },
      /** 重置按钮操作 */
      resetQuery () {
        this.queryParams = {
          uomClassList: undefined,
          unitOfMeasureList: undefined,
          baseUomList: undefined,
          status: undefined
        }
        this.onSearch()
      },
      // 搜索框展开、收起
      toggleAdvanced () {
        this.advanced = !this.advanced
      }
    },
    computed: {
      editWidth () {
        return this.isEdit ? 0 : 160
      },
      columns () {
        return [
          {
            // title: '下单类别',
            dataIndex: 'orderType',
            scopedSlots: { customRender: 'orderTypeRender', title: "orderTypeRenderTitle" },
            align: 'center',
            width: 160
          },
          {
            // title: '销量区间（从）',
            dataIndex: 'salesFrom',
            scopedSlots: { customRender: 'inputNumber', title: "inputNumberTitle" },
            ellipsis: true,
            width: !this.isEdit ? 0 : 160,
            align: 'center'
          },
          {
            // title: '销量区间（到）',
            dataIndex: 'salesTo',
            scopedSlots: { customRender: 'inputNumber', title: "salesToTitle" },
            ellipsis: true,
            width: !this.isEdit ? 0 : 160,
            align: 'center'
          },
          {
             title: '销量区间',
            dataIndex: 'salesShow',
            scopedSlots: { customRender: 'salesShow' },
            ellipsis: true,
            width: this.isEdit ? 0 : 160,
            align: 'center'
          },
          {
            // title: '稳定性区间（从）',
            dataIndex: 'stabilityFrom',
            ellipsis: true,
            width: !this.isEdit ? 0 : 160,
            scopedSlots: { customRender: 'inputNumber', title: "stabilityFromTitle" },
            align: 'center'
          },
          {
            // title: '稳定性区间（到）',
            dataIndex: 'stabilityTo',
            ellipsis: true,
            width: !this.isEdit ? 0 : 160,
            scopedSlots: { customRender: 'inputNumber', title: "stabilityToTitle" },
            align: 'center'
          },
          {
             title: '稳定性区间',
             ellipsis: true,
            dataIndex: 'stabilityShow',
            width: this.isEdit ? 0 : 160,
            scopedSlots: { customRender: 'stabilityShow' },
            align: 'center'
          },
          {
            // title: '类别',
            dataIndex: 'classify',
            scopedSlots: { customRender: 'classify', title: "classifyTitle" },
            width: 170,
            align: 'center'
          },
          {
            title: '创建人',
            dataIndex: 'createName',
            width: 100,
            ellipsis: true,
            align: 'center'
          },
          {
            title: '创建日期',
            dataIndex: 'createTime',
            width: 180,
            scopedSlots: { customRender: 'createTime' },
            align: 'center'
          },
          {
            title: '最后更新人',
            dataIndex: 'updateName',
            width: 100,
            ellipsis: true,
            align: 'center'
          },
          {
            title: '最后更新日期',
            dataIndex: 'updateTime',
            scopedSlots: { customRender: 'updateTime' },
            width: 180,
            align: 'center'
          },
          {
            title: '操作',
            width: 100,
            dataIndex: 'operation',
            scopedSlots: { customRender: 'operation' },
            fixed: 'right'
          }
        ]
      }
    }
  }
  </script>

  <style scoped lang="less">
   .ml30{
    margin-left: 30px;
  }
    .ml20{
    margin-left: 20px;
  }
  .ml10{
    margin-left: 10px;
  }.top-title{
    display: flex;
    justify-content: center;
    align-items: center;

  }.top-title-input{
        width: 60px;
    }/deep/.ant-select {
  width: 150px;
}/deep/.ant-input {
  width: 150px;
}.fs13{
    font-size: 13px;
    color: rgba(0, 0, 0, 0.65);
}
  </style>
